import { z } from "zod";

import { VERTICAL_NAMES } from "../../../constants/constants";
import VerticalRegistry from "../../../constants/verticalRegistry";
import { getPhoneValidationError } from "../../../utils/phoneValidation";

export const searchSchema = z.object({
  vertical: z.string().min(1, "Vertical is required"),
  isd_code: z.string().optional(),
  country_id: z.string().optional(),
  phone: z
    .string()
    .refine(
      (val) => val === "" || /^\d+$/.test(val),
      "Only numbers are allowed",
    )
    .optional(),
  uam_id: z.string().regex(/^\d*$/, "Only integers are allowed").optional(),
  admission_number: z
    .string()
    .refine(
      (val) => val === "" || val.length >= 2,
      "Minimum 2 characters required",
    )
    .optional(),
});

export const validateSearchForm = (values) => {
  const errors = {};

  if (!values.vertical) {
    errors.vertical = "Vertical is required";
    return errors;
  }

  if (values.vertical === VERTICAL_NAMES.IL_SCHOOLS && !values.branch_name) {
    errors.branch = "Branch is required for IL Schools";
    return errors;
  }

  const verticalObj = VerticalRegistry.getVerticalByName(values.vertical);
  const config = verticalObj?.searchConfig;

  if (!config) return errors;

  const allowedFields = Object.keys(config).filter((key) => config[key]);
  const isAnyFilled = allowedFields.some(
    (field) => values[field]?.trim() !== "",
  );

  if (!isAnyFilled) {
    errors.general = "Enter at least one search parameter";
  }

  if (values.phone?.trim()) {
    if (!values.isd_code) {
      errors.isd_code = "Select country code";
    } else {
      const phoneError = getPhoneValidationError(values.phone, values.isd_code);
      if (phoneError) {
        errors.phone = phoneError;
      }
    }
  }

  if (values.uam_id?.trim() && !values.country_id) {
    errors.country_id = "Select country";
  }

  return errors;
};
